import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import initPinia from '@/plugins/InitPinia'
import initBaseScripts from '@/plugins/InitBaseScripts'
import initInjectedComponents from '@/plugins/initInjectedComponents'
import initRegisterLayouts from '@/plugins/RegisterLayouts'
import initRegistrationModules from '@/plugins/RegisterModules'
import InitDirective from '@/plugins/InitDirective'
import print from 'vue3-print-nb'

import '@/assets/scss/styles.scss'

const app = createApp(App)

app.use(initPinia)
app.use(initBaseScripts)
app.use(initInjectedComponents)
app.use(initRegistrationModules)
app.use(initRegisterLayouts)
app.use(InitDirective)
app.use(router)
app.use(print)

app.mount('#app')
;(async () => {
  const Sentry = await import('@sentry/vue')

  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
    sendDefaultPii: true,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.05,
    replaysOnErrorSampleRate: 1.0,

    ignoreErrors: [/ResizeObserver loop limit exceeded/i, /reCAPTCHA Timeout/i],
    denyUrls: [/^chrome-extension:\/\//, /extensions\//],
  })
})()
